import { Div } from "@grassrootly/rn-core";
import { GameStatusesProps } from "../GamePreview.types";
import { GameStatues } from "@grassrootly/api";
import Select from '@grassrootly/rn-core/src/components/common/select/Select';
import { SelectOption } from '@grassrootly/rn-core/src/components/common/select';
import { useConfirmDialog } from '../../../layout/components/confirm-dialog';

export default function GameStatuses({ game, onStatusChanged, availableStatuses, changeStatusInProgress }: GameStatusesProps) {

  const { prompt } = useConfirmDialog();

  const statuses: SelectOption[] = availableStatuses ? 
    availableStatuses.map((x) => ({ value: x, label: x })) : [];

  const selectStatus = (item: SelectOption, index: number) => {
    prompt({
      title: "Change game status",
      message: `Are you sure you want to change game status to ${item.value}?`,
      onYes: () => {
        if (onStatusChanged) {
          onStatusChanged(item.value, game);
        }
      },
    });
  };

  return (
    <Div classNames={["flexRow", "alignContentCenter", "justifyContentCenter"]}>
      <Div
        classNames={[
          "mt-{-20}",
          "btn",
          "br-{8}",
          "pv-{8}",
          "borderPrimary",
          "bw-{1}",
          "bgPrimaryMain"
        ]}
      >
        <Select options={statuses} onSelect={selectStatus} selectedOption={game.status} placeholderText={game.status} forceSelectedOption={true} isLoading={changeStatusInProgress} />
      </Div>
    </Div>
  );
}
